import { render, staticRenderFns } from "./t-alert.vue?vue&type=template&id=c9095004&scoped=true&"
import script from "./t-alert.vue?vue&type=script&lang=js&"
export * from "./t-alert.vue?vue&type=script&lang=js&"
import style0 from "./t-alert.vue?vue&type=style&index=0&id=c9095004&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c9095004",
  null
  
)

export default component.exports